import { useDispatch } from "react-redux"
import React from "react"
import {successStatus} from "../state/apiStatusSlice"


// item = "name of item operation is being performed on"
// operation = "should be "create", "update", or "delete",
// although it is possible to add custom operation, e.g: "assign"

const useApiStatusDispatch = () => {
    const realDispatch = useDispatch()
    const wrappedDispatch = (action, item, operation,message='') => {
        if (typeof action !== 'function') alert('Can only use useApiStatusDispatch with function type actions')
        return realDispatch(action).then(res => {
            res.payload?.success === '1' ? realDispatch(successStatus({item, operation, success:true,message})) 
            : realDispatch(successStatus({item, operation,success:false,message:res.payload?.message}))
            return res
        })
    }
    return wrappedDispatch
}
export default useApiStatusDispatch;